import { Box, Divider, Drawer, Grid, IconButton, Tooltip } from "@mui/material";
import { i18n } from "../../translate/i18n";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { IconsConexaBot } from "./icons";
import { INode } from "./manager";

interface IOption {
  text: string;
  icon: any;
  type: INode["type"];
  subtype: INode["data"]["subtype"];
}

export const ElementsLiteBot = () => {


  const RenderOption = ({ text, icon, type, subtype }: IOption) => {

    const onDragStart = (event: any, type: string, subtype: string, label: string) => {
      event.dataTransfer.setData('application/reactflow', JSON.stringify({ type, subtype, label }));
      event.dataTransfer.effectAllowed = 'move';
    };

    return (
      <Box
        sx={{
          padding: "5px 10px",
          borderRadius: "5px",
          background: (theme) => theme.palette.mode == "dark" ? "#424242" : "#cfd8dc",
          minWidth: "110px",
          cursor: "grab",
          display: "flex",
          alignItems: "center",
          gap: "5px",
          "& svg": {
            width: "20px",
            height: "20px"
          }
        }}
        onDragStart={(event) => onDragStart(event, type, subtype, text)}
        draggable
      >
        {icon}
        {text}
      </Box>
    );
  }

  return (
    <Drawer
      id="elementsLiteBotMenu"
      sx={{
        display: 'none',
        width: 280,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: 280,
          top: '75px',
          height: 'calc(100vh - 75px)',
          padding: '10px'
        },
      }}
      variant="persistent"
      anchor="right"
      open={true}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Tooltip
            title={i18n.t("buttons.close")}
          >
            <IconButton
              sx={{
                float: "right",
                width: "30px",
                height: "30px",
                marginBottom: "10px"
              }}
              onClick={() => {
                const menu = document.getElementById("elementsLiteBotMenu");
                if (menu) menu.style.display = "none";
              }}
            >
              <CloseOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Grid>
      </Grid>

      {/* Eventos */}
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {i18n.t("conexaBots.elementsMenu.event")}
        </Grid>
      </Grid>
      <Divider sx={{ marginTop: "10px", marginBottom: "10px" }} />
      <Grid container spacing={2}>
        {/* <Grid item>
          <RenderOption
            text={i18n.t("conexaBots.nodes.start.title")}
            icon={IconsConexaBot['start']}
            type="start"
            subtype="start"
          />
        </Grid> */}
        <Grid item>
          <RenderOption
            text={i18n.t("conexaBots.nodes.end.transfer")}
            icon={IconsConexaBot['transfer']}
            type="end"
            subtype="transfer"
          />
        </Grid>
        <Grid item>
          <RenderOption
            text={i18n.t("conexaBots.nodes.end.finish")}
            icon={IconsConexaBot['finish']}
            type="end"
            subtype="finish"
          />
        </Grid>
      </Grid>

      {/* Comunicações */}
      <Grid container spacing={2} mt={1}>
        <Grid item xs={12}>
          {i18n.t("conexaBots.elementsMenu.communication")}
        </Grid>
      </Grid>
      <Divider sx={{ marginTop: "10px", marginBottom: "10px" }} />
      <Grid container spacing={2}>
        <Grid item>
          <RenderOption
            text={i18n.t("conexaBots.nodes.condition.message")}
            icon={IconsConexaBot['message']}
            type="condition"
            subtype="message"
          />
        </Grid>
        <Grid item>
          <RenderOption
            text={i18n.t("conexaBots.nodes.condition.question")}
            icon={IconsConexaBot['question']}
            type="condition"
            subtype="question"
          />
        </Grid>
        <Grid item>
          <RenderOption
            text={i18n.t("conexaBots.nodes.condition.quickReply")}
            icon={IconsConexaBot['quickReply']}
            type="condition"
            subtype="quickReply"
          />
        </Grid>
      </Grid>

      {/* Lógicas */}
      <Grid container spacing={2} mt={1}>
        <Grid item xs={12}>
          {i18n.t("conexaBots.elementsMenu.logic")}
        </Grid>
      </Grid>
      <Divider sx={{ marginTop: "10px", marginBottom: "10px" }} />
      <Grid container spacing={2}>
        <Grid item>
          <RenderOption
            text={i18n.t("conexaBots.nodes.condition.simpleCondition")}
            icon={IconsConexaBot['simpleCondition']}
            type="condition"
            subtype="simpleCondition"
          />
        </Grid>
        <Grid item>
          <RenderOption
            text={i18n.t("conexaBots.nodes.condition.compoundCondition")}
            icon={IconsConexaBot['compoundCondition']}
            type="condition"
            subtype="compoundCondition"
          />
        </Grid>
        <Grid item>
          <RenderOption
            text={i18n.t("conexaBots.nodes.condition.await")}
            icon={IconsConexaBot['await']}
            type="condition"
            subtype="await"
          />
        </Grid>
        <Grid item>
          <RenderOption
            text={i18n.t("conexaBots.nodes.condition.openingHour")}
            icon={IconsConexaBot['openingHour']}
            type="condition"
            subtype="openingHour"
          />
        </Grid>
      </Grid>
    </Drawer>
  )
}